import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../Component/img/logo.png";
import otpImage from "../Component/img/login.jfif";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl"; // Adjust the path as needed
import { ToastContainer, toast } from "react-toastify"; // Import toast notifications
import "react-toastify/dist/ReactToastify.css"; // Import styles for toast

const OTP = () => {
  // const [otp, setOtp] = useState(new Array(6).fill("")); // Array to hold OTP digits
  const [otp, setOtp] = useState("");
  const inputRefs = useRef([]); // References to input fields
  const [loading, setLoading] = useState(false); // State for loading state
  const [isResendDisabled, setIsResendDisabled] = useState(false); // State for enabling/disabling resend button
  const [resendTimer, setResendTimer] = useState(30); // Timer for countdown
  const navigate = useNavigate(); // For navigation after successful verification
  const location = useLocation(); // Get current location to retrieve query params

  // Decode Base64 email from the URL
  const decodeBase64 = (string) => {
    try {
      return atob(string); // Decode string from Base64
    } catch (e) {
      return null; // Return null if decoding fails
    }
  };

  // Extract and decode the email from the URL query parameters
  const emailParam = new URLSearchParams(location.search).get("email");
  const email = decodeBase64(emailParam);

  if (!email) {
    toast.error("Invalid or missing email in URL.");
    return null; // Render nothing if email is invalid
  }

  // Handle input change and auto-focus on the next input
  const handleChange = (value, index) => {
    if (isNaN(value)) return; // Allow only numeric input
    const newOtp = [...otp];
    newOtp[index] = value; // Update OTP digit
    setOtp(newOtp);

    // Move to the next input field if a digit is entered
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  // Handle OTP submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const otpCode = otp.trim(); // Trim any accidental spaces
  
    if (otpCode.length < 6) {
      toast.error("Please enter the full 6-digit OTP");
      return;
    }
  
    setLoading(true);
  
    console.log('Sending data to API:', { email, otp: otpCode });
  
    try {
      const response = await axios.post(`${BASE_URL}verify-otpvisitior`, { email, otp: otpCode });
  
      console.log('Full response:', response);
  
      const { visitor_id, visitor_name, visitor_email } = response.data;
  
      if (visitor_id && visitor_email) {
        localStorage.setItem("visitor_id", visitor_id);
        localStorage.setItem("visitor_email", visitor_email);
        localStorage.setItem("visitor_name", visitor_name || "");
  
        toast.success("OTP verified successfully!");
        navigate("/");
      }
  
    } catch (error) {
      console.error('Error details:', error.response?.data || error.message);
  
      const { code, message, visitor_id, visitor_email, visitor_name } = error.response?.data || {};
  
      if (visitor_id && visitor_email) {
        localStorage.setItem("visitor_id", visitor_id);
        localStorage.setItem("visitor_email", visitor_email);
        localStorage.setItem("visitor_name", visitor_name || "");
      }
  
      if (code === "403") {
        toast.info("Redirecting to profile setup due to missing phone.");
        navigate("/profile-fill");
      } else {
        toast.error(message || "Invalid OTP! Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  


  
  
  
  

  // Handle Resend OTP request
  const handleResendOtp = async () => {
    if (isResendDisabled) return; // Prevent sending OTP if disabled

    setIsResendDisabled(true); // Disable resend button
    setResendTimer(30); // Reset resend timer to 30 seconds

    // Start countdown for resend button
    const timer = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer); // Stop countdown when it reaches 0
          setIsResendDisabled(false); // Enable resend button again
        }
        return prev - 1;
      });
    }, 1000);

    try {
      const response = await axios.post(`${BASE_URL}/resend-otp`, { email }); // API call to resend OTP

      // Log the response data for debugging
      console.log('Resend OTP response:', response.data);

      if (response.status === 200) {
        toast.success("OTP resent successfully!");
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      // Log any error details for debugging
      console.error('Resend OTP error:', error);
      toast.error(error.response?.data?.message || "An error occurred!");
    }
  };

  return (
    <div className="">
      <div className="row p-0 m-0 lam">
        <div className="col-md-6 p-0 m-0 justify-content-center d-flex align-items-center">
          <div className="col-md-8">
            <div>
              <img src={logo} className="img-fluid logocls" alt="logo" />
              <h3>Enter OTP</h3>
              <p className="mb-4">
                An OTP has been sent to your email: <b>{email}</b>
              </p>
              <form onSubmit={handleSubmit}>
  <div className="mb-3">
    {/* <label htmlFor="otp" className="form-label">Enter OTP</label> */}
    <input
      type="text"
      id="otp"
      className="form-control"
      maxLength="6"
      placeholder="Enter 6-digit OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      required
    />
  </div>

  <button type="submit" className="btnnlogin mt-3" disabled={loading}>
    {loading ? "Verifying..." : "Verify OTP"}
  </button>
</form>



              <button
                type="button"
                className="btnnlogin mt-3"
                onClick={handleResendOtp}
                disabled={isResendDisabled} // Disable the button while countdown
              >
                {isResendDisabled ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6 p-0 m-0">
          <img src={otpImage} alt="OTP" className="img-fluid lgoin" />
        </div>
      </div>
      <ToastContainer /> {/* Toast container for displaying toasts */}
    </div>
  );
};

export default OTP;
